export const ChartMappingType = {
  CHART_SINGLE_LINE_PREVIEW: 'CHART_SINGLE_LINE_PREVIEW',
  CHART_SINGLE_BAR_PREVIEW: 'CHART_SINGLE_BAR_PREVIEW',
  CHART_SINGLE_LINE: 'CHART_SINGLE_LINE',
  CHART_SINGLE_BAR: 'CHART_SINGLE_BAR',
  CHART_MULTIPLE_LINE: 'CHART_MULTIPLE_LINE',
  CHART_MULTIPLE_LINE_PREVIEW: 'CHART_MULTIPLE_LINE_PREVIEW',
  CHART_MULTIPLE_WIND_DIRECTION: 'CHART_MULTIPLE_WIND_DIRECTION',
};
